import React from 'react';
import { Box } from '@hawkins/components';

export const AppContent = ({ children }: React.PropsWithChildren) => (
  <Box width="100%" height="100%" position="relative" overflow="auto">
    {children}
  </Box>
);
